export default __webpack_public_path__ + "00db474ea26dee5810568e7d4b6c8e97.svg";